import { WEB_PLANS } from '@studio/constants/plans';
import type { PlanTypeState } from '@studio/constants/web-channels';
import { useCustomer } from '@studio/storeV2/customer/hooks/use-customer';

const useIsPlanType = (): PlanTypeState => {
  const { webPlanId } = useCustomer();
  const planId = webPlanId ?? '';

  const isUBP =
    planId === WEB_PLANS.ENTERPRISE_UBP ||
    planId === WEB_PLANS.PROFESSIONAL_UBP ||
    planId === WEB_PLANS.SOCIAL_ONLY_UBP ||
    planId === WEB_PLANS.STARTER_LITE_UBP;

  return {
    isEnterprise: planId === WEB_PLANS.ENTERPRISE,
    isEnterprise4k: planId === WEB_PLANS.ENTERPRISE_4K,
    isEnterpriseUBP: planId === WEB_PLANS.ENTERPRISE_UBP,
    isPro: planId === WEB_PLANS.PROFESSIONAL,
    isProfessionalUBP: planId === WEB_PLANS.PROFESSIONAL_UBP,
    isProLegacyEmbedOnly: planId === WEB_PLANS.PRO_LEGACY_EMBED_ONLY,
    isSocialOnly: WEB_PLANS.SOCIAL_ONLY_LIST.includes(planId),
    isSocialOnlyUBP: planId === WEB_PLANS.SOCIAL_ONLY_UBP,
    isStarterLegacy: planId === WEB_PLANS.STARTER_LEGACY,
    isStarterLite: planId === WEB_PLANS.STARTER_LITE,
    isStarterLiteUBP: planId === WEB_PLANS.STARTER_LITE_UBP,
    isUBP,
    isVideoReview: planId === WEB_PLANS.VIDEO_REVIEW,
    webPlanId: planId,
  };
};

export default useIsPlanType;
